import { IImagesProperty } from "@/types/images.types";
import { create } from "zustand";

interface SliderState {
  slides: IImagesProperty[];
  currentSlide: number;
  setSlides: (slides: IImagesProperty[]) => void;
  setCurrentSlide: (index: number) => void;
}

export const useSliderStore = create<SliderState>((set) => ({
  slides: [],
  currentSlide: 0,
  setSlides: (slides) => set({ slides }),
  setCurrentSlide: (index) => set({ currentSlide: index }),
}));
